import { render } from "./pos-coupons.vue?vue&type=template&id=5536cbb9"
import script from "./pos-coupons.vue?vue&type=script&lang=js"
export * from "./pos-coupons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__